import React, { createContext, useContext, useState } from 'react';
import translations from '../translations';

// Создаем контекст для языка
const LanguageContext = createContext();

// Определение языка из URL
const getLanguageFromUrl = () => {
  const pathSegments = window.location.pathname.split('/');
  if (pathSegments[1] && /^[a-z]{2}$/.test(pathSegments[1])) {
    return pathSegments[1];
  }
  return 'en'; // По умолчанию английский
};

// Провайдер контекста для использования в компонентах
export const LanguageProvider = ({ children }) => {
  // Приоритет: URL > Cookie > Default (en)
  const [language, setLanguage] = useState(getLanguageFromUrl());

  // Обновление языка при изменении URL
  React.useEffect(() => {
    const handleUrlChange = () => {
      const urlLang = getLanguageFromUrl();
      if (urlLang && urlLang !== language) {
        setLanguage(urlLang);
      }
    };

    window.addEventListener('popstate', handleUrlChange);
    return () => window.removeEventListener('popstate', handleUrlChange);
  }, [language]);

  // Функция для получения перевода
  const t = (key) => {
    return translations[language]?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Хук для использования в компонентах
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
